import PageHeader from 'src/core/ui/PageHeader';
import Footer from 'src/core/ui/helpers/Footer';
import ContentCardsContainer, { CardType, ContentCard } from 'src/core/ui/ContentCard';
import { CustomDataGrid } from 'src/core/tables/CustomDataGrid';
import { generateTablePageButtons } from 'src/core/tables/generateTablePageButtons';
import { useBillableItemsRowsTable, useBillableOrdersRowsTable, useBillableOrdersTable } from 'src/pages/orders/payments/billableOrders/useBillableOrdersTable';
import DetailPanelContainer from 'src/core/tables/helpers/DetailPanelContainer';

export const BillableOrdersTablePage = () => {
  const [columns, tableSettings] = useBillableOrdersTable();
  return (
    <>
      <PageHeader title={'Billable Orders'} subTitle={'See orders where invoice can be created'} components={[...generateTablePageButtons(tableSettings)]} />
      <ContentCardsContainer>
        <ContentCard {...{ cardTypes: [CardType.noHeader], contentPadding: 0 }}>
          <CustomDataGrid columns={columns} tableSettings={tableSettings} getDetailPanelContent={(row) => <DetailPanelContent {...{ row }} />} />
        </ContentCard>
      </ContentCardsContainer>
      <Footer />
    </>
  );
};
export default BillableOrdersTablePage;

const DetailPanelContent = ({ row }) => {
  const [columns, tableSettings] = useBillableOrdersRowsTable(row?.row?.BillableOrders);
  return (
    <DetailPanelContainer depth={0}>
      <CustomDataGrid columns={columns} tableSettings={tableSettings} getDetailPanelContent={(row) => <SecondDetailPanelContent {...{ row }} />}></CustomDataGrid>
    </DetailPanelContainer>
  );
};
const SecondDetailPanelContent = ({ row }) => {
  const [columns, tableSettings] = useBillableItemsRowsTable(row?.row?.BillableItems);
  return (
    <DetailPanelContainer depth={1}>
      <CustomDataGrid columns={columns} tableSettings={tableSettings}></CustomDataGrid>
    </DetailPanelContainer>
  );
};
